import { Star } from 'lucide-react';

/**
 * StarRating component using Lucide icons.
 * @param {number} rating - Current rating value (0-5)
 * @param {number} size - Icon size
 * @param {string} color - Color for filled stars
 * @param {string} emptyColor - Color for empty stars
 * @param {number} total - Total stars to show
 */
export default function StarRating({
  rating = 0,
  size = 16,
  color = '#ffc107',
  emptyColor = '#e1e9e9',
  total = 5
}) {
  const fullStars = Math.floor(rating);
  const hasHalf = rating % 1 >= 0.5;

  return (
    <div className="starRating" style={{ display: 'inline-flex', gap: '2px', alignItems: 'center' }}>
      {[...Array(total)].map((_, i) => {
        const isFilled = i < fullStars;
        const isHalf = !isFilled && hasHalf && i === fullStars;

        return (
          <span key={i} style={{ display: 'flex', position: 'relative' }}>
            <Star
              size={size}
              fill={isFilled ? color : 'none'}
              stroke={isFilled ? color : emptyColor}
            />
            {isHalf && (
              <span style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '50%',
                overflow: 'hidden',
                color: color
              }}>
                <Star size={size} fill={color} stroke={color} />
              </span>
            )}
          </span>
        );
      })}
    </div>
  );
}
